
import {map, tap} from 'rxjs/operators';
/**
 * Created by christiancueni on 07/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { AppState } from '../reducers';
import * as auth from '../actions/authentication';
import { ResetGroupsAction } from '../actions/groups';
import { ResetKlassenbuchAction } from '../actions/klassenbuch';
import { UiResetAction } from '../actions/ui';
import { UsersResetAction } from '../actions/users';
import { ResetLabelsAction } from '../admin/labels/labels.actions';
import { ResetNotificationsAction } from '../notifications/notifications.actions';
import { ResetPaymentAction } from '../payment/payment.actions';
import { ResetRolesAction } from '../roles/roles.actions';


@Injectable()
export class LogoutEffect {

    constructor(
        private actions$: Actions,
        private store: Store<AppState>
    ) {}

     logoutSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(auth.AuthActionTypes.AUTH_LOGOUT_SUCCESS),
        tap(() => this.store.dispatch(new ResetGroupsAction())),
        tap(() => this.store.dispatch(new ResetKlassenbuchAction())),
        tap(() => this.store.dispatch(new UiResetAction())),
        tap(() => this.store.dispatch(new UsersResetAction())),
        tap(() => this.store.dispatch(new ResetLabelsAction())),
        tap(() => this.store.dispatch(new ResetNotificationsAction())),
        tap(() => this.store.dispatch(new ResetRolesAction())),
        map(() => new ResetPaymentAction()),))

}
